import React, { useEffect, useState } from "react";

export default function DelightBurst({ trigger, className = "" }) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!trigger) return;
    setActive(true);
    const id = window.setTimeout(() => setActive(false), 650);
    return () => window.clearTimeout(id);
  }, [trigger]);

  if (!active) return null;

  return (
    <span
      className={`rp-delight-burst pointer-events-none absolute inset-0 ${className}`}
      aria-hidden="true"
    />
  );
}
